<div class="content-wrapper table-full-bx">
    <div class="account-settings">
        <div class="row">
            <div class="col-lg-12">
                <div class="ibox ">
                    <div class="ibox-body">
                        <div class="iboxcontent">
                            <h3>Account Settings</h3>
                        </div>
                        <!-- Account settings  -->
                        <div class="row">
                            <div class="col-md-12 col-lg-3 col-sm-12">
                                <!-- Tabs nav -->
                                <div class="nav  nav-pills nav-pills-custom pills-custom">
                                    <a class="nav-link mb-3 p-3 " href="javascript:void(0);"
                                        routerLink="/account-settings/change-password">
                                        <span class=" ">Change password</span>
                                    </a>

                                    <a class="nav-link mb-3 p-3  " href="javascript:void(0);"
                                        routerLink="/account-settings/notification">

                                        <span class=" ">Notifications</span>
                                    </a>

                                    <a class="nav-link mb-3 p-3  active" href="javascript:void(0);"
                                        routerLink="/account-settings/save-card">

                                        <span class=" ">Saved cards</span>
                                    </a>



                                    <a class="nav-link mb-3 p-3 " href="javascript:void(0);"
                                        routerLink="/account-settings/inventory-history">

                                        <span class="">Subscriptions</span>
                                    </a>
                                    <a class="nav-link mb-3 p-3 " href="javascript:void(0);"
                                        routerLink="/account-settings/billing-address">

                                        <span class=" ">Billing address</span>
                                    </a>

                                    <a class="nav-link mb-3 p-3  " href="javascript:void(0);"
                                        routerLink="/account-settings/my-templates">

                                        <span class=" ">My templates</span>
                                    </a>

                                </div>
                            </div>
                            <div class="col-md-12  col-lg-9  col-sm-12 tabwidth">
                                <!-- Tabs content -->
                                <div class="tab-content" id="v-pills-tabContent">
                                    <div class="tab-pane fade  bg-box show active ">
                                        <div class="flexbox">
                                            <div class="iboxcontent">
                                                <h2 class="mainTitle">Saved Cards</h2>
                                            </div>
                                            <div class="col-list-right">
                                                <a data-toggle="modal" data-target="#newCard1" data-dismiss="modal"
                                                    class="remove" (click)="openModal(addMore)">Add New Card</a>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-5 col-lg-5 col-sm-12"
                                                *ngFor="let card of allCards; let i=index;">
                                                <div class="cardBox">
                                                    <div class="cardbk">
                                                        <div class="card-bk-inner-2">
                                                            <!-- <p>Bank name</p> -->
                                                            <div class="card-bk-inner">
                                                                <div class="carddetail">
                                                                    <p>{{card?.cardHolderName}}</p>
                                                                    <h4>**** **** **** {{card?.last4}}</h4>
                                                                </div>
                                                                <div class="carddetail">
                                                                    <p>Set as default</p>
                                                                    <div class="on-off">
                                                                        <label class="switch">
                                                                            <input type="checkbox"
                                                                                [checked]="card.isPrimary ==1"
                                                                                (change)="card.isPrimary==1"
                                                                                *ngIf="card.isPrimary ==1" disabled>
                                                                            <span class="slider round"
                                                                                (click)="setcard(card)"></span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="d-flex justify-content-between">
                                                                <h4>{{card?.expMonth}}/{{card?.expYear.slice(-2)}}</h4>
                                                                <img src="assets/images/ms.svg"
                                                                    *ngIf="card?.cardType =='MasterCard'">
                                                                <img src="../../../../assets/images/visa.png"
                                                                    *ngIf="card?.cardType =='Visa'"
                                                                    style="max-width:60px; max-height:20px">
                                                                <img src="assets/images/american_exp.svg"
                                                                    *ngIf="card?.cardType =='AmericanExp'">
                                                                <img src="assets/images/discover.svg"
                                                                    *ngIf="card?.cardType =='Discover'">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="del-btn text-center">
                                                        <!-- *ngIf="card.isPrimary == 0" -->
                                                        <a class="commonBtn nobk mt-4 width50"
                                                            (click)="delete(card)">Delete</a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="noDataFound" *ngIf="allCards.length == 0">
                                            <h2>No saved card</h2>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<!--Add new card  -->
<ng-template #addMore>
    <div class="modal-body">
        <div class="tab-content">
            <h6 class="pageTitle">Add New Card</h6>
            <form [formGroup]="cardform" (ngSubmit)="createToken()">
                <p class="total" hidden>Total Amount after including Tax:
                    <input type="text" formControlName="amount" readonly>
                </p>
                <div class="form-group">
                    <label for="">Name on the card</label>
                    <input type="" class="form-control" placeholder="Albert stonis" formControlName="name"
                        maxlength="30">
                    <div class="text-danger" *ngIf="cardform.controls['name'].hasError('required') && showErrorCard">
                        *Please enter name. </div>
                </div>
                <div class="form-group">
                    <label for="">Card number</label>
                    <input type="" class="form-control" placeholder="2245 5937 2421 7541" formControlName="CardNumber"
                        maxlength="19" (keyup)="keyUPvalue1($event)">
                    <div class="text-danger"
                        *ngIf="cardform.controls['CardNumber'].hasError('required') && showErrorCard"> *Please enter
                        Card Number. </div>
                    <div class="text-danger"
                        *ngIf="cardform.controls['CardNumber'].hasError('minlength') && showErrorCard"> *Minimum length
                        of 16 characters. </div>
                    <div class="text-danger"
                        *ngIf="!cardform.controls['CardNumber'].hasError('required') && !cardform.controls['CardNumber'].hasError('minlength') && cardform.controls['CardNumber'].hasError('whitespace') && showErrorCard">
                        *Please enter a valid value. </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                        <div class="form-group datepicker">
                            <label for="">Expiry Date</label>
                            <input type="" class="form-control" type="tel" maxlength="5" class="form-control"
                                placeholder="MM / YY" maxlength="5" (keyup)="keyUPvalue($event)"
                                formControlName="CardExpired">
                            <div class="text-danger"
                                *ngIf="cardform.controls['CardExpired'].hasError('required') && showErrorCard"> *Please
                                select Card Exp. </div>
                            <div class="text-danger"
                                *ngIf="cardform.controls['CardExpired'].hasError('minlength') && showErrorCard">
                                *Minimum length of 4 characters. </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label for="">CVV</label>
                            <input type="password" class="form-control" placeholder="123" formControlName="CardCCV"
                                maxlength="3">
                            <div class="text-danger"
                                *ngIf="cardform.controls['CardCCV'].hasError('required') && showErrorCard"> *Please
                                enter CVV Number. </div>
                            <div class="text-danger"
                                *ngIf="cardform.controls['CardCCV'].hasError('minlength') && showErrorCard"> *Minimum
                                length of 3 characters. </div>
                            <div class="text-danger" *ngIf="!cardform.controls['CardCCV'].hasError('required') && !cardform.controls['CardCCV'].hasError('minlength') && 
                  				cardform.controls['CardCCV'].hasError('whitespace') && showErrorCard"> *Please enter a valid
                                value. </div>
                        </div>
                    </div>
                </div>
                <div class="custom-control custom-checkbox" hidden>
                    <input type="checkbox" class="custom-control-input" id="customCheck" formControlName="isSaved"
                        [checked]="cardform.value.isSaved ==1" (change)="cardform.value.isSaved ==1">
                    <label class="custom-control-label" for="customCheck"> Save card for future </label>
                </div>
                <div class="form-group">
                    <input type="submit" class="commonBtn width50" value="Save Card">
                </div>
            </form>
        </div>
    </div>
</ng-template>